import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="Footer">
      <p className="Footer__text">© {new Date().getFullYear()} Take3</p>
    </footer>
  );
}

export default Footer;
